<template>
<Scroll  height=800>
 <div style="width:100%;min-height:950px;min-width:900px; background:#fff;" >
	 <br/>
      <Row> 
            <Col span="10" offset=1> <div id="myGl" style=" height: 400px;"></div></Col>
			<Col span="10" offset=1> <div id="casemyGl" style=" height: 400px;"></div></Col>
      </Row>
	  <Row>
		  <Col span="20" offset=1> <div id="querymyGl" style=" height: 400px"></div></Col>
	  </Row>
 </div>
   </Scroll>
</template>

<script>
import echarts from 'echarts'
import date from '@/utils/date.js'
export default {
    data() {
        return {
            cityList : [],
            queryList : [],
            caseList : [],
            readList : [],
            dom: '',
            flag:true,
            list:[],
			formValidate: {
				 startTime: date.computedDate(new Date(new Date().setDate(new Date().getDate()-3)).toLocaleDateString()),
                 endTime: date.computedDate(new Date(new Date().setDate(new Date().getDate())).toLocaleDateString()),
            },
        }
    },
    methods: {
        //进入首页
        enterIndex(){
            this.$router.replace("/home/main")
        },
		

        ininMap(){
		  let myGl = this.$echarts.init(document.getElementById('myGl'))
         let	option = {
				 title: {
					text: '线索数量统计',
					textStyle: {
					  color: '#000',
                      fontSize: 18,   
					},
					left:'center'
				  },
				  legend: {
					type: 'plain',  // 图列类型，默认为 'plain'
					bottom: '1%',  // 图列相对容器的位置 top\bottom\left\right
					textStyle: {  // 图列内容样式
						  color: '#000',  // 字体颜色
						},					
					data: [   // 图列内容
					  {
						name: '线索数量',
						
					  }
					]
				  },
				xAxis: {
					type: 'category',
					data:   ['2月11日', '2月12日', '2月13日', '2月14日', '2月15日', '2月16日', '2月17日'],//
					axisLine: {       // 坐标轴 轴线
					  show: true,  // 是否显示					 
					  lineStyle: {
						color: '#000',
						width: 1,
						type: 'solid'
					  }
					},
					splitLine:{
                        show:false
                    }
					 
				},
				 
				yAxis: {
					type: 'value',
					 axisLine: {       // 坐标轴 轴线
					 show: true,  // 是否显示					 
					 
					},
					splitLine:{
                        show:false
                    }
				},
				 grid:{
                        top:'20%',//距上边距
                        left:'1%',//距离左边距
                        right:'0%',//距离右边距
                        bottom:'10%',//距离下边距
                        containLabel:true
                    },
				tooltip: {
					  trigger: 'axis',
					  axisPointer: { // 坐标轴指示器，坐标轴触发有效
						type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
					  },
					   // 鼠标移入条形图提示层文字的自定义
					  formatter (params) {
						let relVal = '' //params[0].name
						for (var i = 0, l = params.length; i < l; i++) {
						  
						  relVal +=   params[i].seriesName + ' : ' + params[i].value 
						}
						return relVal
					  }

					},
				series: [{
					name: '线索数量',    
					data:    [120, 100, 110, 100, 90, 110, 50], // dataList,//
					itemStyle: {
						normal: {
							color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
								offset: 0,
								color: "#2378f7" // 0% 处的颜色
							}, {
								offset: 0.6,
								color: "#2378f7" // 60% 处的颜色
							}, {
								offset: 1,
								color: "#83bff6" // 100% 处的颜色
							}], false)
						}
					},
					barWidth: '30%',
					type: 'bar'
				}]
			};
            
          
            if (option && typeof option === "object") {
                myGl.setOption(option, true);
            } 
           
      },

       initTask(){
		    this.cityList=[]
            let start = new Date(this.formValidate.startTime).getTime()
            let end = new Date(this.formValidate.endTime).getTime()
            if(start > end){
                this.$Message.error('结束时间不能小于开始时间');
                return
            } 
            let url = `/api/statistic?type=1&startDate=${this.formValidate.startTime}&endDate=${this.formValidate.endTime}`
            this.req({
                url: url,
                method: 'get'
            }).then(resp => {
                for (let i = 0; i < resp.data.page.length; i++) {
                   
                        this.cityList.push(resp.data.page[i])
                   
                }
                
                  this.ininMap()
            }).catch(error => {
                this.$Message.error('服务器错误:' + error)
            })

			
        },

		 queryininMap(){
           
		  let querymyGl = this.$echarts.init(document.getElementById('querymyGl'))
          let  option = {
				legend: {
					top: 'bottom'
				},
				
				series: [
					{
					name: '经营单位',
					type: 'pie',
					radius: [80, 150],
					center: ['50%', '45%'],
					roseType: 'area',
					itemStyle: {
						borderRadius: 2
					},
					data: [
						{ value: 940, name: '旅游' },
						{ value: 538, name: '文化' },
						{ value: 632, name: '票务' },
						{ value: 730, name: '演出' },
						{ value: 428, name: '小说' }
					]
					}
				]
				};
            
          
            if (option && typeof option === "object") {
                querymyGl.setOption(option, true);
                //myGl.setSeries(seriesData);
            } 
		 
         
           
      },
     

		//案件查询
		   caseininMap(){
			 
		    let casemyGl = this.$echarts.init(document.getElementById('casemyGl'))
		    
            let option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
						// Use axis to trigger tooltip
						type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
						}
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value'
					},
					yAxis: {
						type: 'category',
						 data: ['2月12日','2月13日','2月14日','2月15日','2月16日'],
					},
					series: [
						{
						name: '检索条数',
						type: 'bar',
						stack: 'total',
						label: {
							show: true
						},
						emphasis: {
							focus: 'series'
						},
						itemStyle:{
                        normal:{color:"#73C0DE"},
                       },
						data: [1120, 932, 801, 934, 990]
						},
							{
						name: '检索次数',
						type: 'bar',
						stack: 'total',
						label: {
							show: true
						},
						emphasis: {
							focus: 'series'
						},
						itemStyle:{
                          normal:{color:"#91CB74"},
                        },
						data: [3, 5, 4, 10, 8]
						}
					]
					};
          
            if (option && typeof option === "object") {
                casemyGl.setOption(option, true);
            } 
           
      },
       
    },
    mounted() {
      //  var dom = document.getElementById("myGl");
       // this.dom =dom;
       
		//this.initTask()
		//this.queryinitTask()
		//this.caseinitTask()
		this.ininMap()
		this.queryininMap()
		this.caseininMap()
        
    },
}
</script>
<style lang='less' scoped>
    .bigDataMain{
        width: 100%;
        height: 100%;
        background:#F3F3F3;
          #myGl{
              margin-top: 10px;
          }
        }
    
   
</style>



// WEBPACK FOOTER //
// src/pages/platform/statistics/taskNumSta.vue